export const MENU_MODE_TOOLTIPS = {
  register: "Registre ✶ Parcourir, rechercher et consulter vos mots enregistrés.",
  notes: "Carnet de notes ✶ Consulter et rédiger vos prises de notes.",
  groupings:
    "Groupements thématiques ✶ Réunir des mots sous une thématique commune.",
  capture: "Capture ✶ Ajouter de nouveaux mots à partir d'une définition.",
  training: "Entraînement ✶ Réviser votre vocabulaire avec des fiches.",
  packs: "Paquets ✶ Gérer le noyau actif et la répartition des mots.",
  quest: "Quêtes ✶ Suivre vos objectifs et défis de vocabulaire.",
  game: "Jeu ✶ Retrouver les mots à partir de leurs définitions.",
  collection: "Collection ✶ Consulter vos gemmes, potions, parchemins et objets spéciaux.",
  medals: "Maîtrise ✶ Suivre votre progression et votre grade.",
  stats: "Statistiques ✶ Analyser l'historique et les performances de vos parties.",
  logout: "Se déconnecter",
  cpanel: "Administration ✶ Demandes d'accès et comptes.",
};

export const MENU_FILTER_TOOLTIPS = {
  info: "Tous les mots ✶ Liste complète du registre (filtres avancés disponibles).",
  favorites: "Favoris ✶ Mots marqués d'un cœur.",
  priority: "Prioritaires ✶ Mots à réviser en priorité.",
  success: "Réussites ✶ Mots dont la dernière restitution en jeu était correcte.",
  failures: "Échecs ✶ Mots dont la dernière restitution en jeu était incorrecte.",
  neverPlayed: "Jamais joués ✶ Mots n'ayant encore jamais figuré dans une partie.",
  lastGame: "Dernière partie ✶ Mots proposés lors de votre dernière partie.",
};

export const MENU_MIDDLE_TOOLTIPS = {
  stats:
    "Statistiques du mot, score EWSS, historique des réponses, ajouter en favori et/ou en prioritaire",
  edit: "Définition, extrait de texte, illustration et modifications",
  lastGameSummary:
    "Synthèse de la dernière partie ✶ Répartition des mots selon leur historique de jeu.",
  filteredStats:
    "Statistiques des données filtrées ✶ Maîtrise, mot à revoir, mots jamais joués etc.",
  recency:
    "Récence ✶ Distinguer les mots selon le temps écoulé depuis leur dernière apparition en jeu.",
  settings: "Paramètres ✶ Recherche et affichage de la liste des mots.",
};

export const MENU_GROUPINGS_TOOLTIPS = {
  create: "Nouveau groupement thématique ✶ Créer une thématique pour y réunir des mots.",
  settings: "Préférences d'affichage ✶ Recherche, pastille et code couleur de la liste.",
};

export const MENU_NOTES_TOOLTIPS = {
  read: "Lecture ✶ Quitter le mode modification et consulter la note.",
  readActive: "Lecture ✶ Mode lecture actif.",
  readDisabled: "Lecture ✶ Sélectionnez une note pour la consulter.",
  edit: "Modification ✶ Éditer le titre, la rubrique et le contenu de la note.",
  editActive: "Modification ✶ Mode édition actif.",
  editDisabled: "Modification ✶ Sélectionnez une note en lecture pour l'éditer.",
  save: "Enregistrer ✶ Sauvegarder les modifications de la note active.",
  delete: "Supprimer ✶ Effacer définitivement la note active.",
  deleteDisabled: "Supprimer ✶ Aucune note à supprimer.",
  settings: "Paramètres ✶ Affichage de la liste et préférences de scroll du carnet.",
  create: "Nouvelle note ✶ Créer une prise de note dans le carnet.",
  expand: "Deux pages ✶ Lire la note comme un livre.",
  expandEdit: "Deux pages ✶ Modifier la note comme un livre.",
  expandDisabled: "Deux pages ✶ Sélectionnez une note pour l'afficher.",
  closeSpread: "Fermer ✶ Revenir à la prise de notes.",
};

export const MENU_TRAINING_TOOLTIPS = {
  config: "Configuration ✶ Modifier les filtres de l'entraînement.",
  free: "Entraînement libre ✶ Choisir vos filtres et réviser à votre rythme.",
  quest: "Session de quête ✶ 40 mots, 10 secondes minimum par mot.",
  questUnavailable: "Session de quête ✶ Objectif déjà validé aujourd'hui.",
};

export const MENU_CAPTURE_TOOLTIPS = {
  capture: "Capture ✶ Vérifier et enregistrer un nouveau mot dans votre registre.",
  dictionary: "Dictionnaire ✶ Rechercher un mot sur Wiktionary et Wikipédia.",
  settings: "Paramètres ✶ Comportement à la fin de la capture d'un mot.",
  restoreSource: "Remettre le livre et l'auteur de la dernière capture.",
  pickSource: "Choisir un livre et un auteur déjà enregistrés.",
  clearSource: "Vider le titre du livre et l'auteur.",
  clearDefinition: "Vider la définition.",
  clearExcerpt: "Vider l'extrait.",
  removeIllustration: "Supprimer l'illustration.",
  restartWord:
    "Corriger l'orthographe du mot. Les champs saisis sont conservés, puis le mot doit être vérifié à nouveau.",
  hiddenWords:
    "Les mots trop proches de celui que l'on cherche. Laissés dans la définition, ils livreraient la réponse. On les masque pour que retrouver le mot reste un vrai exercice.",
  wiktionaryIndicative:
    "Les extraits Wiktionary sont donnés à titre indicatif. N'en faites pas une source fiable pour la définition à capturer.",
  wikipediaIndicative:
    "Les extraits Wikipédia sont donnés à titre indicatif. N'en faites pas une source fiable pour la définition à capturer.",
};

export const MENU_MASTERY_TOOLTIPS = {
  progress:
    "Progression de maîtrise ✶ Suivre votre grade EWSS et vos paliers de niveau.",
  history:
    "Observateur d'évènements ✶ Passages de niveau, captures de mots et quêtes.",
};

export const MENU_GAME_PREP_TOOLTIPS = {
  difficulty: "Difficulté ✶ Choisir le mode de jeu et lancer une partie.",
  key: "Utilisation d'un parchemin ✶ Échanger des gemmes contre un parchemin de pouvoir pour la prochaine partie.",
  shortcuts: "Raccourcis clavier ✶ Touches pour utiliser les potions en cours de partie.",
};

export const MENU_COLLECTION_TOOLTIPS = {
  gems: "Collection de gemmes ✶ Pierres gagnées en jeu, à échanger contre potions et parchemins.",
  potions: "Catalogue des potions ✶ Effets et disponibilité des potions.",
  keys: "Parchemins de pouvoir",
};

export const MENU_LIBRARY_TOOLTIPS = {
  home: "Bibliothèque ✶ Liste des livres de la bibliothèque.",
  characters: "Personnages ✶ Associer les passages surlignés à un personnage.",
  search: "Rechercher dans le livre ✶ Trouver un mot ou une expression dans ce livre.",
  reassignPassage: "Changer de personnage ✶ Attribuer ce passage à un autre personnage.",
  unassignPassage: "Retirer le lien ✶ Le passage n'est plus associé. Le surlignage reste.",
  close: "Fermer ✶ Revenir au registre.",
  import: "Importer un livre ✶ Ajouter un EPUB.",
  favorites: "Favoris ✶ Afficher les livres marqués d'un cœur.",
  highlights: "Passages importants, mots à capturer et passages favoris",
  resume: "Poursuivre la lecture",
  passage: "Surligner un passage important",
  word: "Surligner un mot à capturer",
  favorite: "Surligner un passage favori",
  captureWord: "Capturer ce mot",
  removeWord: "Retirer ce mot à capturer",
  removePassage: "Retirer ce passage important",
  removeFavorite: "Retirer ce passage favori",
  openWord: "Ouvrir ce mot dans le livre",
  openPassage: "Ouvrir ce passage dans le livre",
  openFavorite: "Ouvrir ce passage dans le livre",
};

export const FRAME_LAUNCHER_TOOLTIPS = {
  library: "Bibliothèque",
  citizens: "Annuaire du Royaume",
  mail: "Messagerie du Royaume",
  preferences: "Préférences",
};

export const MENU_QUEST_TOOLTIPS = {
  daily: "Journal de quête du Royaume.",
  treasures:
    "Salle des trésors de quête ✶ Reliques obtenues dans les coffres de quête.",
  titles: "Avancement des titres.",
  blasons: "Armorial de Vocabularium.",
  settings: "Paramètres des quêtes ✶ Personnaliser votre nom dans les dialogues.",
};
